/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Best_Finch_ArriveInputs */

const fr_happy_best_finch_arrive = /** @type {(inputs: Happy_Best_Finch_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer les séances par semaine pour le programme`)
};

/**

* @param {Happy_Best_Finch_ArriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const happy_best_finch_arrive = /** @type {((inputs?: Happy_Best_Finch_ArriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Best_Finch_ArriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_happy_best_finch_arrive(inputs)
});